import { render, staticRenderFns } from "./SkupTema2Create.vue?vue&type=template&id=bde980b8&scoped=true&"
import script from "./SkupTema2Create.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde980b8",
  null
  
)

export default component.exports